<template>
	<v-main>
		<v-container class="fill-height justify-center text-center" fluid>
			<v-form ref="locumRatesForm" class="pa-4 pt-1">
				<v-row class="justify-center text-center">
					<v-col>
						<p class="text-h5 font-weight-bold">Hourly rate on Weekdays</p>
					</v-col>
				</v-row>

				<v-row no-gutters class="justify-center text-center pb-5">
					<v-text-field
						:disabled="hasFixedRates"
						single-line
						outlined
						class="rate-number pr-0 pl-0 mr-0 ml-0 pt-0 pb-2"
						style="outline-color: #f00 !important"
						:color="weekday_focus ? 'primary' : '#A3A3A3'"
						height="50px"
						:value="weekdayrateFormatted"
						:rules="weekdayrateRules"
						@focus="onFocus('weekday')"
						@change="change_weekdayrate"
					></v-text-field>
				</v-row>

				<v-row class="justify-center text-center pt-5">
					<v-col>
						<p class="text-h5 font-weight-bold">Hourly rate on Saturdays</p>
					</v-col>
				</v-row>

				<v-row no-gutters class="justify-center text-center pb-5">
					<v-text-field
						:disabled="hasFixedRates"
						single-line
						outlined
						class="rate-number pr-0 pl-0 mr-0 ml-0 pt-0 pb-2"
						:color="saturday_focus ? 'primary' : '#A3A3A3'"
						height="50px"
						:value="saturdayrateFormatted"
						:rules="saturdayrateRules"
						@focus="onFocus('saturday')"
						@change="change_saturdayrate"
					></v-text-field>
				</v-row>

				<v-row class="justify-center text-center pt-5">
					<v-col>
						<p class="text-h5 font-weight-bold">Hourly rate on Sundays and Holidays</p>
					</v-col>
				</v-row>

				<v-row no-gutters class="justify-center text-center">
					<v-text-field
						:disabled="hasFixedRates"
						single-line
						outlined
						class="rate-number pr-0 pl-0 mr-0 ml-0 pt-0 pb-2"
						:color="holiday_focus ? 'primary' : '#A3A3A3'"
						height="50px"
						:value="this.holidayrateFormatted"
						:rules="sundayrateRules"
						@focus="onFocus('holiday')"
						@change="change_holidayrate"
					></v-text-field>
				</v-row>
			</v-form>
			<v-row v-if="this.solo">
				<v-btn text @click="$refs.locumRatesForm.reset()">Clear</v-btn>
				<v-spacer></v-spacer>
				<v-btn class="white--text" color="deep-purple accent-4" depressed @click="SubmitForm()">Update</v-btn>
			</v-row>
		</v-container>
	</v-main>
</template>

<script>
import { mapGetters } from 'vuex';
import { bus } from '@/main';
// import { Auth } from 'aws-amplify'
import axios from 'axios';
import store from '@/store';
export default {
	props: {
		solo: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		name: 'LocumRatesForm',
		minimum: 100,

		weekdayrate: store.getters.user?.working_hours?.weekdays?.rate || null,
		weekdayrateFormatted: store.getters.user?.working_hours?.weekdays?.rate ? 'R' + store.getters.user?.working_hours?.weekdays?.rate : null,
		weekday_focus: false,

		saturdayrate: store.getters.user?.working_hours?.saturday?.rate || null,
		saturdayrateFormatted: store.getters.user?.working_hours?.saturday?.rate ? 'R' + store.getters.user?.working_hours?.saturday?.rate : null,
		saturday_focus: false,

		holidayrate: store.getters.user?.working_hours?.public_holidays?.rate || null,
		holidayrateFormatted: store.getters.user?.working_hours?.public_holidays?.rate ? 'R' + store.getters.user?.working_hours?.public_holidays?.rate : null,
		holiday_focus: false,

		form: false,

		weekdayrateRules: [v => !!v || 'Weekday Rate is required'],
		saturdayrateRules: [v => !!v || 'Saturday Rate is required'],
		sundayrateRules: [v => !!v || 'Sunday/Holiday Rate is required'],
		rules: {
			// email: v => (v || "").match(/@/) || "Please enter a valid email",
			length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
			password: v =>
				(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',
			required: v => !!v || 'This field is required',
		},
	}),
	computed: {
		...mapGetters('tenant', ['tenant']),

		hasFixedRates() {
			if (!this.tenant) return false;
			return this.tenant.settings.workflow.professionalProfile.hasFixedRates;
		},

		fixedRates() {
			return this.tenant.settings.workflow.professionalProfile.rates;
		},
	},
	mounted() {
		if (this.solo) {
			bus.$on('intent:submit-forms:' + this.name, data => {
				if (this.validate()) {
					bus.$emit('update:spinning', true);
					this.postToBackend(data);
				}
			});
		} else {
			bus.$on('intent:submit-forms', data => {
				if (this.validate()) {
					bus.$emit('update:spinning', true);
					this.postToBackend(data);
				}
			});
		}

		if (this.hasFixedRates) {
			const weekdayRate = this.fixedRates.weekdays;
			const saturdayrate = this.fixedRates.saturday;
			const holidayrate = this.fixedRates.publicHolidays;

			this.weekdayrate = weekdayRate;
			this.saturdayrate = saturdayrate;
			this.holidayrate = holidayrate;

			this.weekdayrateFormatted = 'R' + weekdayRate;
			this.saturdayrateFormatted = 'R' + saturdayrate;
			this.holidayrateFormatted = 'R' + holidayrate;
		}
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
		bus.$off('intent:submit-forms:' + this.name);
	},
	methods: {
		validate() {
			return this.$refs.locumRatesForm.validate();
		},
		reset() {
			this.$refs.locumRatesForm.reset();
		},
		resetValidation() {
			this.$refs.locumRatesForm.resetValidation();
		},
		change_weekdayrate(new_value) {
			let new_value_string = new_value.toString();
			let validated = new_value_string.match(/\d+/);

			if (validated != null) {
				this.weekdayrate = Number.parseInt(validated[0]);
				this.weekdayrateFormatted = 'R' + Number.parseInt(validated[0]);
			} else {
				this.weekdayrate = Number.parseInt(validated[0]);
				this.weekdayrateFormatted = 'R' + Number.parseInt(validated[0]);
			}
		},
		onFocus(which) {
			switch (which) {
				case 'weekday':
					this.weekday_focus = true;
					this.saturday_focus = false;
					this.holiday_focus = false;
					break;
				case 'saturday':
					this.weekday_focus = false;
					this.saturday_focus = true;
					this.holiday_focus = false;
					break;
				case 'holiday':
					this.weekday_focus = false;
					this.saturday_focus = false;
					this.holiday_focus = true;
					break;

				default:
					this.weekday_focus = false;
					this.saturday_focus = false;
					this.holiday_focus = false;
					break;
			}
		},

		change_saturdayrate(new_value) {
			let new_value_string = new_value.toString();
			let validated = new_value_string.match(/\d+/);

			if (validated != null) {
				this.saturdayrate = Number.parseInt(validated[0]);
				this.saturdayrateFormatted = 'R' + Number.parseInt(validated[0]);
			} else {
				this.weekdayrate = Number.parseInt(validated[0]);
				this.saturdayrateFormatted = 'R' + Number.parseInt(validated[0]);
			}
		},

		change_holidayrate(new_value) {
			let new_value_string = new_value.toString();
			let validated = new_value_string.match(/\d+/);

			if (validated != null) {
				this.holidayrate = Number.parseInt(validated[0]);
				this.holidayrateFormatted = 'R' + Number.parseInt(validated[0]);
			} else {
				this.holidayrate = Number.parseInt(validated[0]);
				this.holidayrateFormatted = 'R' + Number.parseInt(validated[0]);
			}
		},

		postToBackend() {
			//post to api backend for this form.
			const token = store.getters.jwtToken;

			let body = {
				weekdays: {
					start: '09:00',
					end: '18:00',
					rate: this.weekdayrate.toString(),
					currency: 'ZAR',
				},
				saturday: {
					start: '09:00',
					end: '15:00',
					rate: this.saturdayrate.toString(),
					currency: 'ZAR',
				},
				sundays: {
					start: '09:00',
					end: '17:00',
					rate: this.holidayrate.toString(),
					currency: 'ZAR',
				},
				public_holidays: {
					start: '09:00',
					end: '13:00',
					rate: this.holidayrate.toString(),
					currency: 'ZAR',
				},
			};

			const authHeader = { headers: { Authorization: token } };

			axios
				.put(store.getters.getAPI + '/professionals/workhours', body, authHeader)
				.then(async response => {
					bus.$emit('form-submitted', { form: this.name, status: response.status });
					if (response.status === 200) {
						await axios.put(`${store.getters.getAPI}/calendar/professional/availability/update-all/${store.getters.user.id}`, { working_hours: body }, authHeader);
						store.commit('SET_USER', response.data.data); //refresh the users state. await it.
						bus.$emit('intent:next-step', 'rates-step');
					}
				})
				.finally(() => {
					bus.$emit('update:spinning', false);
				});
		},
		SubmitForm() {
			bus.$emit('intent:submit-forms:' + this.name);
		},
	},
};
</script>
